import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
import {ReactComponent as CancelIcon} from "../../assets/images/cancel.svg";

const DeleteResourceDialog = ({open, handleClose, handleDelete, confirmText}) => {

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent sx={{textAlign: "center", paddingTop: "32px"}}>
                <CancelIcon/>
                <DialogTitle id="alert-dialog-title" sx={{padding: "16px 24px"}}>
                    {"אתה בטוח?"}
                </DialogTitle>
                <DialogContentText id="alert-dialog-description" sx={{padding: "0 24px"}}>
                    {confirmText}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{display: "flex", justifyContent: "center", alignItems: "center", paddingBottom: "32px"}}>
                <Button variant={"outlined"} onClick={handleClose}>בטל</Button>
                <Button
                    sx={{mr: "10px", backgroundColor: "#F16063"}}
                    variant={"contained"}
                    onClick={handleDelete}
                    autoFocus
                >
                    מחק
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteResourceDialog;
